import { create } from 'zustand';
import { MemoMessage, InteractionMode } from '../types';

/**
 * Cache of Memo Studio conversations keyed by `${jobId}:${mode}` so switching to
 * the Chat/Debate tab renders cached messages instantly while revalidating in the
 * background — instead of a blocking skeleton + uncached fetch on every mount.
 */
interface StudioState {
  byKey: Record<string, MemoMessage[]>;
  getMessages: (jobId: string, mode: InteractionMode) => MemoMessage[] | undefined;
  setMessages: (jobId: string, mode: InteractionMode, msgs: MemoMessage[]) => void;
}

const keyOf = (jobId: string, mode: string) => `${jobId}:${mode}`;

export const useStudioStore = create<StudioState>((set, get) => ({
  byKey: {},
  getMessages: (jobId, mode) => get().byKey[keyOf(jobId, mode)],
  setMessages: (jobId, mode, msgs) =>
    set((s) => ({ byKey: { ...s.byKey, [keyOf(jobId, mode)]: msgs } })),
}));
